import { safeLocalStorage } from './safeLocalStorage';

const COOKIE_EXPIRE = 'Thu, 01 Jan 1970 00:00:00 GMT';

function getCookieDomainCandidates(hostname = '') {
  const candidates = [''];

  if (!hostname) {
    return candidates;
  }

  candidates.push(`domain=${hostname}`);

  const parts = hostname.split('.').filter(Boolean);
  for (let index = 0; index < parts.length - 1; index += 1) {
    candidates.push(`domain=.${parts.slice(index).join('.')}`);
  }

  return candidates;
}

export function clearAccessibleCookies({
  cookie = typeof document !== 'undefined' ? document.cookie : '',
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
  writeCookie,
} = {}) {
  if (!cookie) {
    return;
  }

  const assignCookie = writeCookie || ((value) => {
    if (typeof document !== 'undefined') {
      document.cookie = value;
    }
  });

  const domainCandidates = getCookieDomainCandidates(hostname);

  cookie.split(';').forEach((entry) => {
    const name = entry.split('=')[0]?.trim();
    if (!name) {
      return;
    }

    domainCandidates.forEach((domain) => {
      const domainPart = domain ? `; ${domain}` : '';
      assignCookie(`${name}=; expires=${COOKIE_EXPIRE}; path=/${domainPart}`);
    });
  });
}

export function clearClientAuthStorage() {
  safeLocalStorage.clear();

  try {
    sessionStorage.clear();
  } catch (error) {
    console.error('Unable to clear sessionStorage:', error);
  }

  clearAccessibleCookies();
}
